import React, { useEffect, useState, useContext } from 'react'
import { useHistory, Link } from 'react-router-dom'
import UserContext from '../../context/UserContext'

import api from '../../services/api'

import Moment from 'react-moment'

import { makeStyles } from '@material-ui/core/styles'
import { Typography, Paper, Divider } from '@material-ui/core'
import { History, Description, CreateOutlined, PeopleOutlined, NavigateNextOutlined, BusinessOutlined, SubjectOutlined, FormatListBulletedOutlined, DoneOutlineOutlined } from '@material-ui/icons'

import logo from '../../assets/logo.png'
import './styles.css'

import { useAlert } from 'react-alert'

const useStyles = makeStyles({
    titleStyle: {
        marginTop:'50px'
    },
    iconStyle: {
        fontSize: '14px'
    },
    dividerStyle: {
        marginTop: '8px',
        marginBottom: '8px'
    },
    typStyle: {
        marginBottom: '16px'
    },
    tarefaStyle: {
        marginBottom: '36px'
    },
    fileStyle: {
        fontSize: '14px',
        marginRight: '8px'
    },
    historyStyle: {
        fontSize: '12px',
        marginRight: '1px'
    },
    innerTypStyle: {
        color: '#757575',
        fontSize: '12px',
        textTransform: 'uppercase',
        marginRight: '4px'
    },
    smallTitleStyle: {
        color: '#002884'
    }
})

function Ata() {

    const [show, setShow] = useState(false)

    const { userData } = useContext(UserContext)
    const history =  useHistory()
    const classes = useStyles()
    const alert = useAlert()

    const [ata, setAta] = useState({
        participantesClientes: [],
        participantesFN: [],
        proximosPassos: []
    })
    const [ataOwner, setAtaOwner] = useState({})
    const [versao, setVersao] = useState([])

    useEffect(() => {
        if(!userData.user) {
            history.push("/")
        }
    })

    useEffect(() => {        
        async function ataInfoHandler() {
            try {
                let token = localStorage.getItem('auth-token')
                let ataId = localStorage.getItem('ata-id')
                const ataRes = await api.get(`/api/ata/minhas/${ataId}`, { headers: { "x-auth-token": token } })
                const userRes = await api.get('/api/user/perfil', { headers: { "x-auth-token": token } })
                const versaoRes = await api.get(`/api/ata/minhas/${ataId}/versoes`, { headers: { "x-auth-token": token } })
                setAta(ataRes.data)
                setAtaOwner(userRes.data)
                setVersao(versaoRes.data)
            } catch (err) {
                alert.show('Não foi possível fazer a leitura da ata de reunião. Por favor, tente novamente.', { title: "Algo deu errado.", closeCopy: "OK" })
                history.push('/perfil')
            }
        }

        ataInfoHandler()
    // eslint-disable-next-line
    }, [])

    function storeVersaoId(id) {
        localStorage.setItem('versao-id', id)
    }

    return (
        <Paper elevation={6}>
            <div className="leitura-container">

                <center><img src={logo} alt="Xerlock - Analytics & Data Mining" style={{ width: '210px', height: '100px', marginTop: '60px' }} /></center>

                <Typography 
                    className={classes.titleStyle} 
                    align="left" 
                    variant="h6" 
                >
                   ATA DE REUNIÃO
                </Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />
                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Autor <CreateOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ataOwner.nome}</Typography>
                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Cliente <BusinessOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.cliente}</Typography>
                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Assunto <SubjectOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.assunto}</Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Participantes <PeopleOutlined className={classes.iconStyle} />
                </Typography>
                
                <br />
                <Typography component={'span'} className={classes.innerTypStyle}>FN:</Typography>
                {ata.participantesFN.map(participanteFN => (
                    <Typography display="block">{participanteFN.emailFN}</Typography>
                ))}
                
                <br />
                <Typography component={'span'} className={classes.innerTypStyle}>Clientes:</Typography>
                {ata.participantesClientes.map(participanteCliente => (
                    <Typography display="block">{participanteCliente.emailCliente}</Typography>
                ))}
                
                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Pontos abordados <FormatListBulletedOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.pontosAbordados}</Typography>
                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Decisões tomadas <DoneOutlineOutlined className={classes.iconStyle}/>
                </Typography>
                <Typography className={classes.typStyle}>{ata.decisoesTomadas}</Typography>

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography 
                    className={classes.smallTitleStyle} 
                    align="left" 
                    variant="overline"
                >
                    Próximos passos <NavigateNextOutlined className={classes.iconStyle}/>
                </Typography>

                <br/>
                {ata.proximosPassos.map(proximoPasso => (
                    <Typography display="block">
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Responsável: </Typography>{proximoPasso.responsavel}
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Tarefa: </Typography>{proximoPasso.tarefa}
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Prazo: </Typography><Moment add={{ days: 1 }} format="DD/MM/YYYY">{proximoPasso.prazo}</Moment>                        
                        <br/>
                        <Typography component={'span'} display="inline" className={classes.innerTypStyle}>Código Redmine: </Typography>#{proximoPasso.codigoRedmine}
                        <br/>
                        <br/>
                    </Typography>
                ))}

                <Divider className={classes.dividerStyle} variant="fullWidth" />

                <Typography color="textSecondary" variant="caption">Ata de reunião criada em <Moment format="DD/MM/YYYY">{ata.criadoEm}</Moment> às <Moment format="HH">{ata.criadoEm}</Moment>h<Moment format="mm">{ata.criadoEm}</Moment></Typography>
                    
                <br/>
                <br/>
                <button className="redmine-button" onClick={() => setShow(!show)}><History className={classes.historyStyle} /> Vizualizar outras versões</button>
                { 
                    show && 
                    <ul>
                        {versao.map(ver => (
                            <li key={ver._id}>
                                <Description className={classes.fileStyle} />
                                <Link onClick={() => storeVersaoId(ver._id)} className="versoes" to='/versao-ata' >
                                    Versão de <Moment format="DD/MM/YYYY">{ver.t}</Moment> às <Moment format="HH">{ver.t}</Moment>h<Moment format="mm">{ver.t}</Moment>
                                </Link>                            
                            </li>
                        ))}
                    </ul>
                }
                
            </div>
        </Paper>
    )
}

export default Ata
